import React from 'react';

export const SlideControl = (props) => {
    const handleClick = (e) => {
        e.preventDefault();
        props.handleClick(props.id);
    };
    return (
        <li className="slideControl">
            <a onClick={handleClick}>+</a>
        </li>
    );
}